import styled from 'styled-components'

export const ExceptionItemsContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing.sp24};
`

export const TransactionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props =>
    props.index % 2 === 0 ? props.theme.colors.text.inverse : props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const DateAndMenuGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const ChipsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: ${props => props.theme.spacing.sp24};
`
